import { httpClient } from '@api/interceptors';

export const getInvoiceRecipients = async (
  _invoiceId: string,
): Promise<{ email: string; id: string }[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { id: '1', email: 'test1@test.com' },
        { id: '2', email: 'test2@test.com' },
        { id: '3', email: 'test3@test.com' },
        { id: '4', email: 'test4@test.com' },
        { id: '5', email: 'test5@test.com' },
        { id: '6', email: 'test6@test.com' },
        { id: '7', email: 'test7@test.com' },
        { id: '8', email: 'test8@test.com' },
        { id: '9', email: 'test9@test.com' },
        { id: '10', email: 'test10@test.com' },
        { id: '11', email: 'test11@test.com' },
        { id: '12', email: 'test12@test.com' },
        { id: '13', email: 'test13@test.com' },
        { id: '14', email: 'test14@test.com' },
        { id: '15', email: 'test15@test.com' },
        { id: '16', email: 'test16@test.com' },
        { id: '17', email: 'test17@test.com' },
        { id: '18', email: 'test18@test.com' },
        { id: '19', email: 'test19@test.com' },
        { id: '20', email: 'test20@test.com' },
        { id: '21', email: 'test21@test.com' },
        { id: '22', email: 'test22@test.com' },
        { id: '23', email: 'test23@test.com' },
        { id: '24', email: 'test24@test.com' },
        { id: '25', email: 'test25@test.com' },
        { id: '26', email: 'test26@test.com' },
        { id: '27', email: 'test27@test.com' },
        { id: '28', email: 'test28@test.com' },
        { id: '29', email: 'test29@test.com' },
        { id: '30', email: 'test30@test.com' },
        { id: '31', email: 'test31@test.com' },
        { id: '32', email: 'test32@test.com' },
        { id: '33', email: 'test33@test.com' },
        { id: '34', email: 'test34@test.com' },
        { id: '35', email: 'test35@test.com' },
        { id: '36', email: 'test36@test.com' },
        { id: '37', email: 'test37@test.com' },
        { id: '38', email: 'test38@test.com' },
        { id: '39', email: 'test39@test.com' },
        { id: '40', email: 'test40@test.com' },
        { id: '41', email: 'test41@test.com' },
        { id: '42', email: 'test42@test.com' },
        { id: '43', email: 'test43@test.com' },
        { id: '44', email: 'test44@test.com' },
        { id: '45', email: 'test45@test.com' },
        { id: '46', email: 'test46@test.com' },
        { id: '47', email: 'test47@test.com' },
        { id: '48', email: 'test48@test.com' },
        { id: '49', email: 'test49@test.com' },
        { id: '50', email: 'test50@test.com' },
        { id: '51', email: 'test51@test.com' },
      ]);
    }, 1000);
  });
};

export const getInvoiceAttachments = async (
  _invoiceId: string,
): Promise<{ name: string; id: string }[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { id: 'dqwf1', name: 'test1.pdf' },
        { id: '2qwf', name: 'test2.pdf' },
        { id: 'asd3', name: 'test3.pdf' },
        { id: 'dddd4', name: 'test4.pdf' },
        { id: 'xc5', name: 'test5.pdf' },
      ]);
    }, 1000);
  });
};

export const downloadInvoice = async (invoiceId: string): Promise<Blob> => {
  return httpClient.get(`invoices/${invoiceId}`).json();
};

export const downloadInvoicePDF = async (invoiceId: string) => {
  return httpClient.get(`invoices/${invoiceId}/pdf`).blob();
};

export const downloadInvoiceCSV = async (invoiceId: string) => {
  return httpClient.get(`invoices/${invoiceId}/csv`).blob();
};
